import React from 'react';
import { Stack } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';

import PaiAutoComplete, { OptionType } from 'features/ui/base-components/pai-auto-complete';
import { BasicActionDialog } from 'features/ui/base-dialogs';
import { ManualTag } from '../contact-management.types';

interface Props {
  open: boolean;
  loading: boolean;
  tags: ManualTag[];
  selectedTags: OptionType[];

  handleTagSelectionChange(event: React.ChangeEvent<HTMLInputElement>, newValue: OptionType[]): void;
  handleClose(): void;
  handleEditTags(): void;
}

const EditManualTagsDialog: React.FC<Props> = ({
  open,
  loading,
  tags,
  selectedTags,
  handleTagSelectionChange,
  handleClose,
  handleEditTags
}) => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  const options = tags.map((tag) => ({ label: tag.name, value: tag._id }));

  return (
    <BasicActionDialog
      open={open}
      loading={loading}
      dialogTitle={t('editTags')}
      maxWidth="xs"
      proceedButtonText={t('save')}
      handleProceed={handleEditTags}
      cancelButtonText={t('cancel')}
      handleClose={handleClose}
    >
      <Stack spacing={2} className={classes.dialogContent}>
        <PaiAutoComplete
          options={options}
          label={t('tags')}
          selected={selectedTags}
          multiple
          limitTags={3}
          disableClearable
          onChange={handleTagSelectionChange}
        />
      </Stack>
    </BasicActionDialog>
  );
};

const useStyles = makeStyles()(() => ({
  dialogContent: {
    // e.g. marginTop: theme.spacing(1),
  }
}));

export default EditManualTagsDialog;
